<script setup>
import Footer from '@/components/Footer.vue';
import BlockMbox from '@/components/BlockMbox.vue';
import { onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const logoPath = computed(() => {
  const currentStore = route.query["store"] ? route.query["store"].toLowerCase() : null
  let logoPath = "Edoki_logo.svg"

  if (currentStore) {
    if (currentStore === "bayard-de") {
      logoPath = "Logo_Sailer.svg";
    } else if (currentStore.includes("bayard")) {
      logoPath = "Logo_Bayard.svg";
    }
  }

  return logoPath;
});

onMounted(async () => {
  document.title = "Montessori Preschool";
});
</script>

<template>
  <div class="app-layout">
    <BlockMbox />
    <Footer :logo-path="logoPath" />
  </div>
</template>